"use client";
import {
  Image_default
} from "./chunk-KBWHYFNM.mjs";
import {
  Button_default
} from "./chunk-WBZIOSC6.mjs";

// src/components/sections/SectionRotate/SectionRotate.tsx
import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var SectionRotate = forwardRef(
  function SectionRotate2({ referId, title, description, buttons, cards }) {
    return /* @__PURE__ */ jsx(
      "div",
      {
        className: "pt-[80px] lg:pt-[100px] pb-[40px] md:pb-[80px] mx-24",
        id: referId,
        children: /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-24 lg:gap-[40px] m-auto max-w-[1280px]", children: [
          /* @__PURE__ */ jsxs("div", { className: "lg:w-[620px]", children: [
            /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-8", children: [
              /* @__PURE__ */ jsx(
                "h2",
                {
                  dangerouslySetInnerHTML: {
                    __html: title
                  },
                  className: "sm:w-[500px] md:w-[620px] font-display text-4xl lg:text-6xl font-bold leading-[38px] md:leading-[48px]"
                }
              ),
              /* @__PURE__ */ jsx("p", { className: "md:mb-[16px] lg:mb-24 lg:w-[538px] font-sharon text-[18px] lg:text-[20px] leading-[26px] lg:leading-[28px]", children: description })
            ] }),
            /* @__PURE__ */ jsx("div", { className: "hidden md:flex flex-col md:flex-row gap-16 justify-center items-start w-full md:w-max", children: buttons.map((item, index) => /* @__PURE__ */ jsx(Button_default, { ...item }, index)) })
          ] }),
          /* @__PURE__ */ jsx("div", { className: "flex lg:grid flex-wrap lg:grid-cols-2 gap-24 justify-center items-center", children: cards.map(({ tag, title: title2, description: description2, images }, index) => /* @__PURE__ */ jsxs(
            "div",
            {
              className: `${index === 0 ? "lg:row-span-2 lg:max-h-[696px] justify-center items-center md:h-[410px] lg:h-full" : "lg:flex-row-reverse md:h-[410px] lg:h-[336px] lg:pr-0  justify-center items-center"} flex flex-col w-[312px] lg:w-full max-h-[410px] justify-end items-end border-2 lg:items-center rounded-2xl p-24 lg:p-40 gap-24 lg:gap-16 border-display-100
                `,
              style: {
                background: "linear-gradient(0deg, #eff4f8 0%, #fff 101.89%)"
              },
              children: [
                /* @__PURE__ */ jsx(
                  "div",
                  {
                    className: `hidden lg:flex ${index !== 0 ? "lg:h-[310px] lg:max-w-[300px] min-h-[250px] w-full" : "h-[496px] justify-center items-center self-center"}`,
                    children: /* @__PURE__ */ jsx("div", { className: "self-center w-full h-auto min-h-[250px] max-h-[466px]", children: /* @__PURE__ */ jsx(
                      Image_default,
                      {
                        src: images.web.path,
                        alt: images.web.alternativeText,
                        width: index === 0 ? 548 : 300,
                        height: index === 0 ? 466 : 310,
                        className: "object-contain w-full min-h-[250px]",
                        layout: "responsive"
                      }
                    ) })
                  }
                ),
                /* @__PURE__ */ jsx("div", { className: `hidden md:flex lg:hidden relative w-full`, children: /* @__PURE__ */ jsx(
                  Image_default,
                  {
                    src: images.tablet.path,
                    alt: images.tablet.alternativeText,
                    width: 260,
                    height: 228,
                    className: "object-contain"
                  }
                ) }),
                /* @__PURE__ */ jsx(
                  "div",
                  {
                    className: `flex md:hidden relative w-full justify-center items-center`,
                    children: /* @__PURE__ */ jsx(
                      Image_default,
                      {
                        src: images.mobile.path,
                        alt: images.mobile.alternativeText,
                        width: 260,
                        height: 228,
                        className: "object-contain"
                      }
                    )
                  }
                ),
                /* @__PURE__ */ jsxs("div", { className: "lg:flex lg:flex-col gap-8 lg:gap-4 lg:justify-end w-full lg:h-full", children: [
                  tag && /* @__PURE__ */ jsx("div", { className: "flex justify-center items-center py-4 px-8 w-max bg-stone-200 rounded-[16px]", children: /* @__PURE__ */ jsx("p", { className: "font-sans text-sm lg:text-base font-semibold leading-3 lg:leading-4", children: tag }) }),
                  /* @__PURE__ */ jsx("h5", { className: "font-display text-[20px] lg:text-[32px] font-bold leading-[28px] lg:leading-[40px]", children: title2 }),
                  /* @__PURE__ */ jsx("p", { className: "max-w-[350px] lg:font-sans text-[18px] lg:text-[20px] leading-[26px] lg:leading-[30px]", children: description2 })
                ] })
              ]
            },
            index
          )) })
        ] })
      }
    );
  }
);
var SectionRotate_default = SectionRotate;

export {
  SectionRotate_default
};
